const getClientId = () => {

    if (window.location.host.split(".").length === 1) return process.env.REACT_APP_IDENTITY_CLIENT_ID;

    // const [subdomain] = window.location.host.replace("www.","").split(".");
    return process.env.REACT_APP_IDENTITY_CLIENT_ID ;// + (subdomain ? subdomain : "");
}

export default getClientId;
